
import styles from './MessageSending.module.css';
function MessageSending() {


  return (
    // Status region rather than a decorative animation: the dots are the only
    // signal that a reply is coming, so screen-reader users need it announced
    // without focus moving.
    <div className={styles.messageSendingWrapper} role="status" aria-label="Assistant is typing">
      <svg viewBox="0 0 100 100" className={styles.messageSendingCircle} xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="gray" />
      </svg>
      <svg viewBox="0 0 100 100" className={styles.messageSendingCircle} xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="gray" />
      </svg>
      <svg viewBox="0 0 100 100" className={styles.messageSendingCircle} xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="gray" />
      </svg>
    </div>
  );
}
export default MessageSending;
